import React from "react";
import { Tag, TagProps } from "@verily-src/react-design-system";

export const SingleLineTag: React.FC<TagProps> = ({ color, label }) => {
  return (
    <Tag
      color={color}
      label={label}
      sx={{
        whiteSpace: "nowrap",
      }}
    />
  );
};
